module.exports = __webpack_public_path__ + "img/pad.e36d6489.svg";